<template>
  <div id="app">
    <!-- 登录页：不显示左侧菜单，只显示登录界面 -->
    <router-view v-if="$route.path === '/login'" />
    <!-- 其他页面：使用后台布局，左侧菜单 + 顶部 + 内容 -->
    <admin-layout v-else />
  </div>
</template>

<script>
import AdminLayout from './layout/AdminLayout.vue'

export default {
  name: 'App',
  components: { AdminLayout }
}
</script>

